/* 
  Attention!
  Please, do not change it on your own - this function should be synched with the same function on BFF side
*/
export const encodeStoreAddress = (
  storeAddress: string | null | undefined,
): string => {
  if (!storeAddress) {
    return "";
  }
  const result = storeAddress
    ?.replace(/[\s_]+/g, "-")
    .toLowerCase()
    .replace(/&/gi, "-and-")
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .replace(/[^a-zA-Z0-9-]/gi, "")
    .replace(/[-]+/g, "-")
    .replace(/^-/, "")
    .replace(/-$/, "");

  return result;
};
